import {
    Box,
    Button,
    Flex,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    useMediaQuery,
} from '@chakra-ui/react'
import { CustomModal } from '@core/components/Modal/Modal'
import { useGetPolicyQuery } from '@core/app/api/globalApi'
import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

interface PolicyModalProps {
    isOpen: boolean
    onClose: () => void
}

export const PolicyModal = ({ isOpen, onClose }: PolicyModalProps) => {
    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useState(0)
    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })

    const { appTheme } = useAppTheme()
    const ButtonBackground = appTheme?.newSettings?.general?.ButtonBackground || 'EDEEF0'
    const ButtonText = appTheme?.newSettings?.general?.ButtonText || 'B0B0B0'
    const BackgroundText = appTheme?.newSettings?.general?.BackgroundText || '1A1A1A'

    // Використовуємо темний колір для тексту, щоб він був видимий на білому фоні
    const textColor = BackgroundText === 'FFFFFF' || BackgroundText === 'ffffff' || !BackgroundText ? 'gray.800' : `#${BackgroundText}`

    // Отримуємо дані для Privacy Policy
    const { data: privacyData } = useGetPolicyQuery({
        type: 'privacy-policy',
    })

    // Отримуємо дані для User Agreement
    const { data: agreementData } = useGetPolicyQuery({
        type: 'user-agreement',
    })

    const handleTabChange = (index: number) => {
        setActiveTab(index)
    }

    return (
        <CustomModal
            isOpen={isOpen}
            onClose={onClose}
            title={t('10764') || 'Policies'}
            size={isDesktop ? '4xl' : 'full'}
            isHeaderVisible={true}
            isFooterVisible={false}
            scrollBehavior="inside"
            body={
                <Box p={6}>
                    <Tabs index={activeTab} onChange={handleTabChange} variant="unstyled">
                        <TabList
                            mb={6}
                            display="flex"
                            gap="20px"
                            borderBottom="1px solid #E2E8F0"
                            alignItems="center"
                        >
                            <Tab
                                px={0}
                                py={0}
                                pb="3px"
                                fontFamily="'Open Sans', sans-serif"
                                fontWeight={500}
                                fontStyle="normal"
                                fontSize="14px"
                                lineHeight="20px"
                                letterSpacing="0px"
                                verticalAlign="middle"
                                color={activeTab === 0 ? '#0C0C0D' : '#4B4B4E'}
                                border="none"
                                _focus={{ boxShadow: 'none' }}
                                _selected={{
                                    borderBottom: '3px solid #000',
                                    color: '#0C0C0D',
                                    pb: 0
                                }}
                                _hover={{ background: 'transparent' }}
                            >
                                {t('4636')} {/* Privacy Policy */}
                            </Tab>

                            <Tab
                                px={0}
                                py={0}
                                fontFamily="'Open Sans', sans-serif"
                                fontWeight={500}
                                fontStyle="normal"
                                fontSize="14px"
                                lineHeight="20px"
                                letterSpacing="0px"
                                verticalAlign="middle"
                                color={activeTab === 1 ? '#0C0C0D' : '#4B4B4E'}
                                border="none"
                                _focus={{ boxShadow: 'none' }}
                                _selected={{
                                    borderBottom: '3px solid #000',
                                    color: '#0C0C0D',
                                }}
                                _hover={{ background: 'transparent' }}
                            >
                                {t('4635')} {/* User Agreement */}
                            </Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel p={0}>
                                <Box
                                    className="content"
                                    color={textColor}
                                    maxH="60vh"
                                    overflowY="auto"
                                    pr={2}
                                >
                                    {privacyData && parse(privacyData?.data.text)}
                                </Box>
                            </TabPanel>
                            <TabPanel p={0}>
                                <Box
                                    className="content"
                                    color={textColor}
                                    maxH="60vh"
                                    overflowY="auto"
                                    pr={2}
                                >
                                    {agreementData && parse(agreementData?.data.text)}
                                </Box>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Box>
            }
        />
    )
}
